
import { AssessmentAnswers } from '@/types/assessment';

export const filterLearningStrategyQuestions = (
  categoryQuestions: any[],
  answers: AssessmentAnswers
) => {
  const q34Answer = answers[34] as string;
  const q44Answer = answers[44] as string;
  
  return categoryQuestions.filter(q => {
    // Question 35 conditionnelle à Q34
    if (q.id === 35) {
      return q34Answer === "Oui" || q34Answer === "En cours";
    }
    // Question 45 conditionnelle à Q44 (Si oui, lesquels ?)
    if (q.id === 45) {
      return q44Answer === "Oui";
    }
    return true;
  });
};

export const canProceedLearningStrategy = (
  currentStep: number,
  totalSteps: number,
  profileQuestions: any[],
  questionsByCategory: Record<string, any[]>,
  categories: string[],
  answers: AssessmentAnswers,
  contactInfo: any
): boolean => {
  if (currentStep === 0) return true;
  
  if (currentStep === 1) {
    return profileQuestions.every(q => answers[q.id]);
  }
  
  if (currentStep >= 2 && currentStep < 2 + categories.length) {
    const categoryIndex = currentStep - 2;
    const category = categories[categoryIndex];
    const categoryQuestions = questionsByCategory[category] || [];
    
    const filteredQuestions = filterLearningStrategyQuestions(categoryQuestions, answers);
    
    return categoryQuestions.every(q => {
      // Question 35 est conditionnelle et optionnelle
      if (q.id === 35) {
        const q34Answer = answers[34] as string;
        if (q34Answer !== "Oui" && q34Answer !== "En cours") {
          return true;
        }
        return answers[q.id] && String(answers[q.id]).trim() !== '';
      }
      // Question 45 est conditionnelle et optionnelle  
      if (q.id === 45) {
        const q44Answer = answers[44] as string;
        if (q44Answer !== "Oui") {
          return true;
        }
        return answers[q.id] && String(answers[q.id]).trim() !== '';
      }
      return answers[q.id];
    });
  }
  
  if (currentStep === totalSteps - 2) {
    const requiredFields = Object.entries(contactInfo).filter(([key]) => key !== 'rgpdConsent');
    return requiredFields.every(([, value]) => String(value).trim() !== '') && contactInfo.rgpdConsent;
  }
  
  return true;
};
